import React, { Component } from 'react';
import { Link, withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import Pagination from "react-js-pagination";
import $ from 'jquery';
import {
  Row,
  Col,
  Modal,
  Table,
  OverlayTrigger,
  ButtonToolbar,
  Tooltip,
  Button
} from "react-bootstrap";

import { scrollToTopValidate,PageTitle } from "../Helpers/SettingHelper";
import Header from '../Layouts/Header';
import MenuSidebar from '../Layouts/MenuSidebar';

import { GET_ROUTELIST,GET_DELETEROUTE  } from '../../actions';

class List extends Component {
  
  constructor(props)
  {
    super(props); 
    this.state = {
      routelist:''
    };
    
    var qs = require('qs');
    var admin_id = localStorage.getItem("admin_id");
    var postobject = {
    activePage: 1,
    search_all: '',
    admin_id: admin_id
    };
    this.props.getRouteList(qs.stringify(postobject));
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    }

   
    componentDidMount() {
      document.title = PageTitle('Route List');
      if(localStorage.getItem('admin_id') === null){
      this.props.history.push('/');
      }
   }

   handlePageChange(pageNumber) {
    // console.log(`active page is ${pageNumber}`);
     this.setState({activePage: pageNumber});

     var qs = require('qs');

     var admin_id = localStorage.getItem("admin_id");

     var postobject = {
       activePage: pageNumber,
       search_all: this.state.search_all,
       admin_id: admin_id
     };
     this.props.getRouteList(qs.stringify(postobject))
   }

   handleInputChange(event) {
   const {name, value} = event.target;      
   this.setState({
     [name]: value
   });
   
 }

 handleFormSubmit = () => {
        
  this.setState({Loading:true});
  var qs = require('qs');
  const formPayload = this.state;
   var admin_id = localStorage.getItem("admin_id");
  var postObject = {             
    activePage   : 1,
    search_all : formPayload.search_all,
    admin_id: admin_id         
  };
  //console.log(postObject);
  this.props.getRouteList(qs.stringify(postObject));

} 



   componentWillReceiveProps(Props){

    if (Object.keys(Props.routelist).length > 0) {
      if (Props.routelist[0]["status"] === "success") {
        this.setState({ totalRecord : Props.routelist[0].records_count, routelist: Props.routelist[0]["routelist"] });
      }
    }

    if (Object.keys(Props.deleteroute).length > 0) {
      if (Props.deleteroute[0]["status"] === "success") {
        this.setState({
          routelist: Props.deleteroute[0]["routelist"],
        });
      }

      this.setState({statusmessage: Props.deleteroute[0].message});

            setTimeout(
            function() {
              this.setState({statusmessage:''})
            }
            .bind(this),
            3000
          );
     window.location.reload(); 
    }
     
   }

   deleteroute(id){
    var qs = require('qs');
    var postObject = {
      admin_id : localStorage.getItem("admin_id"),
      route_id  :id
    };
    console.log(postObject);
  this.props.getDeleteRoute(qs.stringify(postObject));
}

routelist() {
    var routelist = this.props.routelist[0];
    if (routelist != "undefined" && routelist != null) {
      if (routelist.status == "success") {
        if (Object.keys(routelist).length > 0) {
          const routelistDetails = routelist.routelist.map(
            (routelist, Index) => {
              let sno = Index+1;
              if(routelist.route_status == 'A'){
                var status = 'Active';
              }else{
                  status = 'Inactive';
              }
              var istyle = { width: 100};
              return (
                <tr key={routelist.route_id}>
					<td>{sno}</td>
					<td>
					{routelist.route_name}
					</td> 
					<td>{routelist.r_start_point}</td>
                   <td>{status}</td>
                  <td className="actiongroup">

                    <Link to={{ pathname: '/route-edit/'+routelist.route_id}} className="" title="Edit">  <i className="fa fa-edit" aria-hidden="true"></i></Link>
                    <Link onClick={this.deleteroute.bind(this,routelist.route_id)} className="" title="Duplicate">  <i className="fa fa-trash" aria-hidden="true"></i></Link>
                  </td>
                </tr>
              );
            }
          );
          return routelistDetails;
        }
      } else {
        return (
          <tr>
            <td colspan="8" className="v-align-nr">
              No Result
            </td>
          </tr>
        );
      }
    }else {
      return (
        <tr>
          <td colspan="8" className="v-align-nr">
            No Result
          </td>
        </tr>
      );
    }
  }
  


  render() {
    return (
      <div className="wrapper"> 
 
    <Header />
    <MenuSidebar currentpage="route" />  
      
      <div className="content"> 
        <div className="content-wrapper">
            <div className="car-listing-wrap">

              <div className="listing-header">
                <div className="title">
                  <h3>Routes</h3>
                </div>

                <div className="search-list">
                   <form className="edit" id="edit" onSubmit={ e => { this.handleFormSubmit(this); e.preventDefault(); }} >     
                    <div className="search-inner">
                      <input type="text" name="search_all" onChange={this.handleInputChange} className="form-control" value={this.state.search_all} placeholder="Search" /> 
                     <button className="" type="submit">Submit</button>
                    <div className="erroremail"></div>
                  </div>
                 </form>
                </div>
                <div className="add_button">  
                    <a className="add" href='/route-add'>Add</a> 
                </div>  
              </div>            
              {/*<div className="statusmessage"></div>*/}

              <div className="car-listing-row">
                <Table striped bordered hover>
                  <thead>
                  <tr>
                  <th>S.No</th>
                  <th>Route Name</th>   
                  <th>Route Location</th>
                  <th>Status</th>
                  <th>Action</th>
                   </tr>
                  </thead>
                  <tbody>{this.routelist()}</tbody>
                </Table>
                <div className="text-center">
                  <Pagination
                  activePage={this.state.activePage}
                  itemsCountPerPage={10}
                  totalItemsCount={this.state.totalRecord}
                  pageRangeDisplayed={5}
                  onChange={this.handlePageChange.bind(this)}
                  />
                </div>
              </div>

            </div> 
        </div>  
      </div>
      
    </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    routelist: state.routelist,
    deleteroute: state.deleteroute,
   

  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getRouteList: (formVal) =>{
      dispatch({ type: GET_ROUTELIST, formVal});
   },
   getDeleteRoute: (formPayload) =>{
     dispatch({ type: GET_DELETEROUTE, formPayload });
   },
   
  }
}
export default connect(mapStateTopProps, mapDispatchToProps)(withRouter(List));